import React, { useState, useEffect } from 'react';
import { fetchFeedbackAnalytics } from '../../api/client';
import FeedbackAnalytics from '../FeedbackAnalytics/FeedbackAnalytics';
import FeedbackList from '../FeedbackList/FeedbackList';

export default function FeedbackTab() {
  const [analyticsData, setAnalyticsData] = useState(null);

  useEffect(() => {
    fetchFeedbackAnalytics()
      .then((res) => setAnalyticsData(res.data))
      .catch(() => setAnalyticsData(null));
  }, []);

  return (
    <div>
      <FeedbackAnalytics analytics={analyticsData} />
      <FeedbackList />
    </div>
  );
}
